import React, { useState, useEffect } from "react";
import { getOutletCashAccount } from "../../../../../services/sales/outletService";
import { useFormikContext } from "formik";
import {
  FormDateField,
  FormSelectField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import { Table } from "react-bootstrap";
import { Card } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { Typography } from "@material-ui/core";
function PosPayment({ onSubmitPayment, onCloseDialog }) {
  const { values, setFieldValue } = useFormikContext();
  const [cashAccount, setCashAccount] = useState([]);
  const [cashAccountOptions, setCashAccountOptions] = useState([]);

  async function getOutletCashAccountData(outletID) {
    const response = await getOutletCashAccount(outletID);
    const { data } = response.data;
    const cashAccountOptionsTmp = [];
    cashAccountOptionsTmp.push({
      label: "Cash Account",
      value: 0,
    });

    for (const account of data.outletCashAccount) {
      if (account.payMethod === 1) {
        cashAccountOptionsTmp.push({
          value: account.accountID,
          label: account.cashTitle,
        });
      }
    }
    if (cashAccountOptionsTmp.length > 0) {
      setCashAccountOptions(cashAccountOptionsTmp);
    }
    setCashAccount(data.outletCashAccount);
  }

  useEffect(() => {
    getOutletCashAccountData(values.outletID);
  }, [values.outletID]);

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <Card>
            <Card.Header>
              <Table borderless size="sm" responsive="xl">
                <tbody>
                  <tr>
                    <td style={{ width: "50%" }}>
                      <Typography variant="h6" className="kt-font-bolder">
                        Total Payment
                      </Typography>
                    </td>
                    <td style={{ width: "0%" }}></td>
                    <td style={{ width: "0%" }}></td>
                    <td style={{ width: "50%" }}>
                      <Typography
                        variant="h6"
                        component="div"
                        className="kt-font-bolder"
                      >
                        <NumberFormat
                          value={values.total}
                          displayType={"text"}
                          thousandSeparator={true}
                          decimalScale={2}
                          renderText={(value) => (
                            <div className="float-right">
                              {values.currencyCode} {value}
                            </div>
                          )}
                        />
                      </Typography>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <FormSelectField
                    label="Payment Method"
                    name="payMethod"
                    options={[
                      { label: "Cash", value: 1 },
                      { label: "Debit", value: 2 },
                      { label: "Credit", value: 3 },
                      { label: "Pay Later", value: 4 },
                    ]}
                    onSelectChange={(value) => {
                      setFieldValue("cashAccountID", 0);
                      const cashAccountOptionsTmp = [];
                      cashAccountOptionsTmp.push({
                        label: "Cash Account",
                        value: 0,
                      });
                      for (const account of cashAccount) {
                        if (value === account.payMethod) {
                          cashAccountOptionsTmp.push({
                            label: account.cashTitle,
                            value: account.accountID,
                          });
                        }
                      }
                      setCashAccountOptions(cashAccountOptionsTmp);
                    }}
                  />
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  {values.payMethod < 4 ? (
                    <FormSelectField
                      label="Cash Account"
                      name="cashAccountID"
                      options={cashAccountOptions}
                    />
                  ) : (
                    <FormDateField label="Deadline Date" name="deadlineDate" />
                  )}
                </div>
              </div>
              {values.payMethod === 1 ? (
                <div className="row">
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <FormTextField
                      label="Pay Amount"
                      name="payAmount"
                      currencyField
                      onChangeValue={(value) => {
                        if (value) {
                          const changeAmount =
                            parseFloat(value) - parseFloat(values.total);
                          setFieldValue("change", changeAmount);
                        }
                      }}
                    />
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <FormTextField
                      label="Change"
                      name="change"
                      currencyField
                      readonly
                    />
                  </div>
                </div>
              ) : null}
              {values.payMethod === 2 || values.payMethod === 3 ? (
                <div className="row">
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <FormTextField label="Card Number" name="cardNo" />
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <FormTextField label="Card Holder Name" name="cardName" />
                  </div>
                </div>
              ) : null}
            </Card.Body>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
}

export default PosPayment;
